import * as types from './mutation-types'
import {REMOVE_ROOM_ORDER_COUNT} from "./mutation-types";

export default {
    [types.ADD_RESERVATION] (state, data) {
        state.reservations.push(data)
    },

    [types.ADD_RESERVATIONS] (state, data) {
        state.reservations = data
    },

    [types.LOAD_RESERVATION](state, data) {
        let reservationExist = state.reservations.find(x => x.id === data.id)
        if(reservationExist){
            state.reservations = state.reservations.map((x) => {
                if(x.id === data.id){
                    return data
                }

                return x
            })
        }else{
            state.reservations.push(data)
        }
    },

    [types.SET_RESERVATION](state, data) {
        state.reservations = state.reservations.map((x) => {
            if(x.id === data.id){
                return data
            }
            return x
        })
    },

    [types.REMOVE_RESERVATION](state, id) {
        state.reservations = state.reservations.filter((x) => x.id != id )
    },
}


